// @ts-nocheck

import { createSelector } from 'reselect';

import { getLocationHashFromProps } from '../../selectors/_propsGetters_';
import { selectEntitiesMatches } from '../../selectors/entities/matches/entitiesMatchesPrimary.selector';
import {
  selectMultiviewDisplayOptions,
  selectMultiviewItemPerLine,
  selectMultiviewList,
  selectMultiviewMode,
  selectMultiviewScrollToHeader,
  selectMultiviewUserOption,
} from '../../selectors/multiview/multiviewPrimary.selector';
import { selectRuntimeIsWTVEnabled } from '../../selectors/runtime/runtimePrimary.selector';
import { selectUserPrefsShowWTV } from '../../selectors/user/userPrimary.selector';
import { MatchEntity } from '../../states/entities/matches';
import { type MatchState } from '../../states/entities/matches';
import { type Selector } from '../../types/selectors';

const selectMatchList: Selector<Array<MatchState>> = createSelector(
  [selectMultiviewList, selectEntitiesMatches],
  (matchIds, matches) => matchIds.map((matchId) => matches[matchId]).filter(Boolean),
);

const selectList: Selector<Array<number>> = createSelector([selectMatchList], (list) =>
  list.reduce((acc, match) => (!MatchEntity.isEnded(match) ? [...acc, match.matchId] : acc), []),
);

const selectShowMatchList: Selector<boolean> = createSelector(
  [getLocationHashFromProps],
  (locationHash) => !!~locationHash.indexOf('multiplexEventList'),
);

const selectMultiviewProps = createSelector(
  [
    selectMultiviewMode,
    selectMultiviewDisplayOptions,
    selectList,
    selectMultiviewItemPerLine,
    selectMultiviewUserOption,
    selectMultiviewScrollToHeader,
    selectShowMatchList,
    selectRuntimeIsWTVEnabled,
    selectUserPrefsShowWTV,
  ],
  (mode, displayOptions, list, itemPerLine, userOption, scrollToHeader, showMatchList, isWTVEnabled, showWTV) => ({
    mode,
    displayOptions,
    list,
    itemPerLine,
    userOption,
    expandElement: '#page',
    scrollToHeader,
    showMatchList,
    isWTVEnabled,
    showWTV,
  }),
);

export default selectMultiviewProps;
